import { render, staticRenderFns } from "./m-feature-card.vue?vue&type=template&id=6285604e"
import script from "./m-feature-card.vue?vue&type=script&lang=js"
export * from "./m-feature-card.vue?vue&type=script&lang=js"
import style0 from "./m-feature-card.vue?vue&type=style&index=0&id=6285604e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports